export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-8015HD_white-6199506518561e0dc4974c21198596b9.webp";